import { Button, colors, ModalActions, ModalHeader, Stack } from '@ui-components/neo.tax';
import { SyntheticEvent } from 'react';

import { CsvLogo, CsvUploadInstructions, useCsvFileUrl } from '@neo.tax/shared';

import {
  EXAMPLE_DATA_STRINGIFIED,
  HEADERS_STRINGIFIED,
} from './rd-business-components-upload-instruction-modal.constants';
import { StyledModal } from './rd-business-components-upload-instruction-modal.styled';

type RdBusinessComponentsUploadInstructionModalProps = {
  close: () => void;
  isOpen: boolean;
  loading: boolean;
  submit: () => void;
};

export const RdBusinessComponentsUploadInstructionModal = ({
  close,
  isOpen,
  loading,
  submit,
}: RdBusinessComponentsUploadInstructionModalProps): React.ReactElement => {
  const templateCsvUrl = useCsvFileUrl(HEADERS_STRINGIFIED);
  const exampleCsvUrl = useCsvFileUrl(EXAMPLE_DATA_STRINGIFIED);

  const onSubmit = (e: SyntheticEvent): void => {
    e.preventDefault();
    submit();
  };

  return (
    <StyledModal isOpen={isOpen}>
      <Stack as="form" direction="column" onSubmit={onSubmit}>
        <Stack direction="column" gap={4}>
          <ModalHeader icon={<CsvLogo />} iconBgColor={colors.white} title="Upload Business Components CSV" />
          <Stack direction="column" gap={2}>
            <CsvUploadInstructions
              title="Add one row per business component. Separate keywords with semicolons."
              templateCsvUrl={templateCsvUrl}
              templateCsvName="business-components-csv-upload-template.csv"
              exampleCsvUrl={exampleCsvUrl}
              exampleCsvName="business-components-csv-upload-example.csv"
            />
          </Stack>
        </Stack>

        <ModalActions hasTopBorder={false}>
          <Button variant="white" rounded="regular" size="base" onClick={close}>
            Cancel
          </Button>
          <Button disabled={loading} variant="primary" rounded="regular" size="base" type="submit">
            {loading ? 'Loading...' : 'Upload'}
          </Button>
        </ModalActions>
      </Stack>
    </StyledModal>
  );
};
